import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { DffGroupedContent } from "@dffedb/util";

import { MaalerAflaesningKvitteringService } from "../maaler-aflaesning/maaler-aflaesning-kvittering.service";
import { InstallationMaalerAflaesning } from "./model/installation-maaler-aflaesning.model";

@Injectable({ providedIn: "root" })
export class InstallationMaalerAflaesningKvitteringService {
    constructor(private readonly maalerAflaesningKvitteringService: MaalerAflaesningKvitteringService) {}

    public genererKvittering(model: InstallationMaalerAflaesning): Observable<DffGroupedContent> {
        return this.maalerAflaesningKvitteringService.genererKvittering(model.aflaesning, model.dato);
    }
}
